var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigicardprem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14723_236526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5681 10.7415L4.18178 10.6497C2.35843 10.6447 0.869987 12.4647 0.863824 14.7067L0.809481 34.4789C0.803319 36.721 2.28174 38.5491 4.10509 38.5541L37.4915 38.6459C39.3148 38.6509 40.8032 36.8309 40.8094 34.589L40.8638 14.8167C40.8698 12.5746 39.3914 10.7465 37.5681 10.7415ZM39.2157 34.5846C39.2126 35.7461 38.4414 36.689 37.4968 36.6864L4.11048 36.5946C3.16587 36.592 2.39995 35.6449 2.40315 34.4834L2.45749 14.7111C2.46068 13.5496 3.23179 12.6067 4.1764 12.6093L37.5628 12.7011C38.5074 12.7037 39.2733 13.6508 39.2701 14.8123L39.2157 34.5846Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94889 15.6588C6.86195 15.6531 5.15832 17.7363 5.15127 20.3024C5.14422 22.8684 6.83644 24.961 8.92331 24.9667C11.0103 24.9725 12.7139 22.8893 12.7209 20.3232C12.728 17.7571 11.0358 15.6646 8.94889 15.6588ZM8.9287 23.0072C7.7205 23.0039 6.74078 21.7924 6.74486 20.3068C6.74894 18.8211 7.73531 17.615 8.94351 17.6184C10.1517 17.6217 11.1314 18.8332 11.1273 20.3188C11.1233 21.8044 10.1369 23.0105 8.9287 23.0072Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.385 19.3353L26.2695 19.3323C25.8295 19.3311 25.4715 19.7688 25.47 20.3098C25.4685 20.8509 25.8241 21.2906 26.2641 21.2918L27.3796 21.2949C27.8196 21.2961 28.1776 20.8583 28.1791 20.3173C28.1807 19.7763 27.8251 19.3365 27.385 19.3353Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4774 19.3251L15.4296 19.303C14.9896 19.3018 14.6316 19.7395 14.6301 20.2805C14.6286 20.8216 14.9842 21.2613 15.4242 21.2625L23.472 21.2846C23.912 21.2858 24.27 20.8481 24.2715 20.307C24.2731 19.7661 23.9174 19.3263 23.4774 19.3251Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.728 27.0977L25.8476 27.0705C25.4076 27.0693 25.0496 27.5071 25.0481 28.0481C25.0466 28.5892 25.4022 29.0289 25.8422 29.0301L35.7226 29.0572C36.1626 29.0584 36.5206 28.6207 36.5221 28.0797C36.5236 27.5386 36.168 27.0989 35.728 27.0977Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7156 31.3123L16.6718 31.26C16.2318 31.2588 15.8738 31.6965 15.8723 32.2376C15.8708 32.7786 16.2264 33.2183 16.6664 33.2195L35.7102 33.2719C36.1502 33.2731 36.5082 32.8353 36.5097 32.2943C36.5111 31.7533 36.1556 31.3136 35.7156 31.3123Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14723_236526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 49.1852,
    fill: "inherit",
    transform: "translate(0.902344) rotate(0.157475)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigicardprem);
export default __webpack_public_path__ + "static/media/digicardprem.f2a228d013aa2622c066fe2f2fc09d5b.svg";
export { ForwardRef as ReactComponent };